import React, { useEffect, useState } from "react";
import ModalContainer from "../../../common/ModalContainer";
import "./IndicatorSetting.scss";
import { Button, Form } from "react-bootstrap";
import { ADD_TV_ALERTS_ENTRY, ADD_TV_ALERTS_EXIT, CHANGE_ENTRY_NUM, CHANGE_EXIT_NUM, EDITING_TV_ALERT, FINISHED_TV_SETTING_MODAL } from "../../../../actions/create-bot-type";
import { useDispatch, useSelector } from "react-redux";
import useInput from "../../../hooks/useIndicatorInput";
import copy from "copy-to-clipboard";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { BotType } from "../../../../Const";
import IsRequiredModule from "./IsRequiredModule";
import useCheckbox from "../../../hooks/useCheckbox";



const TvAlertSettingModal = (props) => {
  const {t} = useTranslation()
  const { onHide,isEntry,newBot } = props;
  const dispatch = useDispatch();
  const alertUrl = "https://web.forexhero.ai/tvapi"

  const isGridBot = newBot.botType===BotType.grid
 
  const tvAlerts = isEntry ? newBot.tvAlertsEntry : newBot.tvAlertsExit;
  const editingTvAlert = useSelector(
    (state) => state.createBot.editingTvAlert
  );
  const [isRequired,bindIsRequired, setIsRequired] = useCheckbox(
    editingTvAlert.valid_sec?true:false
  );
  const [validity, bindValidity, setValidity] = useInput(editingTvAlert.valid_sec, 0);
  
  const tvAlertString = editingTvAlert && {
      checksum:editingTvAlert.checksum,
      type:isEntry?"entry":"exit",
      order:editingTvAlert.order
  }
  const saveTvAlert = ()=>{
      dispatch({
        type:isEntry?ADD_TV_ALERTS_ENTRY:ADD_TV_ALERTS_EXIT,
        payload: {...editingTvAlert,valid_sec:isRequired?validity:0}
      })
      dispatch({
        type: isEntry ? CHANGE_ENTRY_NUM : CHANGE_EXIT_NUM,
        payload: 1,
      });
      onHide()
  }
  const changeOrder = (val)=>{
    dispatch({
        type:EDITING_TV_ALERT,
        payload:{
          ...editingTvAlert,order:val,is_compulsory:isRequired?1:0
        }
    });
  }
  const clickCopy = (type) => {
    switch (type) {
        case "url":
            copy(alertUrl);
            break;
        case "checksum":
            copy(JSON.stringify(tvAlertString));
            break;
    
        default:
            break;
    }
    
    toast.success(t("copied-msg"));
  };
  return (
    <ModalContainer
      show={true}
      onHide={onHide}
      title={t("tv-setting")}
    >
      <div className="indicator-setting">
        
        <div
        className=""
        
        >
        <Form.Group>
            <p>{t("tv-indicator-msg")}</p>
            <div className="label-switch pos-relative">
            <p className="tv-alert-url">{alertUrl}</p>
            <span className="alert-copy" onClick={()=>clickCopy("url")}><i className={`far fa-copy`} ></i></span>
            </div>
            
        </Form.Group>
        {(isEntry && !isGridBot) && 
        <Form.Group>
            <div className="label-switch ">
                <div>
                 <Form.Label>{t("sel-order-name")}</Form.Label>
                 </div>
                 <div>
                    <select className="form-control" value={editingTvAlert?editingTvAlert.order:(isEntry?"base":"exit")} onChange={(e)=>changeOrder(e.target.value)}>
                        <option value={`base`} key={1}>Base</option>
                        <option value={`extra`} key={2}>Extra</option>
                    </select>
                 </div>
            
            </div>
            
        </Form.Group> }
        <div>
          <label>{t("required")}:</label>
          <input type="checkbox"  className="input-bg-color" {...bindIsRequired} checked={isRequired}/>
      </div>
      {isRequired?<>
        <div>
            <label>{t("Validity Period")}:</label>
            <input type="number" {...bindValidity} className="input-bg-color"/>
          </div>
      </>:<></>}
        <Form.Group>
           
            <div className="label-switch pos-relative tv-string">
            <p>{JSON.stringify(tvAlertString)}</p>
            <span className="alert-copy" onClick={()=>clickCopy("checksum")}><i className={`far fa-copy`} ></i></span>
            </div>
            
        </Form.Group>
       <hr></hr>
        <Form.Group>
            {t("tv-indicator-note")}
        </Form.Group>
        </div>
        <div className="d-flex justify-content-around">
        <Button onClick={()=>onHide()} variant="secondary" className="width-200">
        {t("cancel")}
        </Button>
        <Button onClick={()=>saveTvAlert()} variant="success" className="width-200">
        {t("save")}
        </Button>
        </div>
      </div>
    </ModalContainer>
  );
};

export default TvAlertSettingModal;
